import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { graphql, gql } from 'react-apollo'
import { redirectTo } from 'frontend_core/dist/helpers/http'
import { containerIds } from 'modules/ui'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { setUIState } from 'modules/ui'
import Path from 'routes/path'
import { helpUrl, wwwUrl, isCurrentPage } from 'frontend_core/dist/helpers/url'
import AccountMenu from 'components/business/shared/AccountMenu'

class HeaderContainer extends React.Component {
  constructor(props) {
    super(props)
    props.actions.setUIState(containerIds.BUSINESS_HEADER, { showMenu: false })
  }

  renderLoggedIn() {
    const { ui, data, actions, config } = this.props
    const match = this.props.match || { params: {} }
    const currentUser = data.viewer
    const companies = data.viewer.companies || { results: [] }
    const company = data.company

    return (
      <header>
        <div className="dashboard-container">
          <div className="business-header clearfix">
            <h1 className="fl">
              <a href="/" className="business-header__logo">
                {i18n.t('spacemarket')}
              </a>
            </h1>
            <AccountMenu
              data={data}
              ui={ui}
              actions={actions}
              config={config}
            />
            <div className="business-header__smp">
              <input
                type="checkbox"
                className="site-header__drawer-check"
                id="site-header__drawer"
              />
              <label
                className="business-header__drawer-menu-btn"
                htmlFor="site-header__drawer"
              >
                <i className="fa fa-bars" style={{ color: '#ffffff' }} />
              </label>
              <label
                className="site-header__drawer-close-menu"
                htmlFor="site-header__drawer"
              />
              <nav className="site-header__drawer-menu">
                <ul>
                  <li>
                    <ul>
                      <li className="site-header__drawer-menu-list">
                        <a href={Path.employees(match.params.username)}>
                          <i className="fa fa-users" />
                          {i18n.t('page.header.employees')}
                        </a>
                      </li>
                      <li className="site-header__drawer-menu-list">
                        <a href={Path.reservations(match.params.username)}>
                          <i className="fa fa-file-text-o" />
                          {i18n.t('page.header.reservations')}
                        </a>
                      </li>
                      <li className="site-header__drawer-menu-list">
                        <a href={Path.summaries(match.params.username)}>
                          <i className="fa fa-dashboard" />
                          {i18n.t('page.header.paymentInformation')}
                        </a>
                      </li>
                      <li className="site-header__drawer-menu-list">
                        <a href={Path.setting(match.params.username)}>
                          <i className="fa fa-cog" />
                          {i18n.t('page.shared.l_00029')}
                        </a>
                      </li>
                      <li className="site-header__drawer-menu-list">
                        <a href={helpUrl()}>
                          <i className="fa fa-question" />
                          {i18n.t('page.header.setting')}
                        </a>
                      </li>
                      <li className="site-header__drawer-menu-list">
                        <a href={Path.logoutAccount(config.URL || '')}>
                          <i className="fa fa-sign-out" />
                          {i18n.t('page.shared.l_00069')}
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h2 className="site-header__drawer-menu-title">
                      {i18n.t('page.shared.l_00070')}
                    </h2>
                    <ul>
                      <li className="site-header__drawer-menu-list">
                        <a href={wwwUrl('/')}>SPACEMARKET</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h2 className="site-header__drawer-menu-title">
                      {i18n.t('page.header.busiessAccount')}
                    </h2>
                    {companies.results.map(result => (
                      <p
                        key={result.id}
                        className="site-header__drawer-menu-list"
                      >
                        <a href={`/companies/${result.username}`}>
                          {result.name}
                        </a>
                      </p>
                    ))}
                  </li>
                  <li>
                    <h2 className="site-header__drawer-menu-title">
                      {i18n.t('page.header.personalAccount')}
                    </h2>
                    <p className="site-header__drawer-menu-list">
                      <a href={wwwUrl('/dashboard')}>{currentUser.name}</a>
                    </p>
                  </li>
                </ul>
              </nav>
            </div>
            <div
              id="js-search"
              className="site-header__search-sm pc-hide__sm-show"
              style={{ display: 'block' }}
            />
            <div className="business-header__search sm-hide">
              <div className="site-header__search-menu">
                <ul>
                  <li className="business-header__search-menu-item">
                    <a
                      className={`business-header__search-menu-button${
                        isCurrentPage(
                          match.url || '',
                          `/companies/${match.params.username}/employees`,
                        )
                          ? ' is-current'
                          : ''
                      }`}
                      href={Path.employees(match.params.username)}
                    >
                      {i18n.t('page.header.employees')}
                    </a>
                  </li>
                  <li className="business-header__search-menu-item">
                    <a
                      className={`business-header__search-menu-button${
                        isCurrentPage(
                          match.url || '',
                          `/companies/${match.params.username}/reservations`,
                        )
                          ? ' is-current'
                          : ''
                      }`}
                      href={Path.reservations(match.params.username)}
                    >
                      {i18n.t('page.header.reservations')}
                    </a>
                  </li>
                  <li className="business-header__search-menu-item">
                    <a
                      className={`business-header__search-menu-button${
                        isCurrentPage(
                          match.url || '',
                          Path.summaries(match.params.username),
                        )
                          ? ' is-current'
                          : ''
                      }`}
                      href={Path.summaries(match.params.username)}
                    >
                      {i18n.t('page.header.paymentInformation')}
                    </a>
                  </li>
                  <li className="business-header__search-menu-item">
                    <a
                      className={`business-header__search-menu-button${
                        isCurrentPage(
                          match.url || '',
                          `/companies/${match.params.username}/setting`,
                        )
                          ? ' is-current'
                          : ''
                      }`}
                      href={`/companies/${match.params.username}/setting`}
                    >
                      {i18n.t('page.shared.l_00029')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    )
  }

  renderAnonymous() {
    const { config } = this.props

    return (
      <header>
        <div className="dashboard-container">
          <div className="business-header clearfix">
            <h1 className="fl">
              <a href="/" className="business-header__logo">
                {i18n.t('spacemarket')}
              </a>
            </h1>
            <ul className="site-header__nav sm-hide">
              <li>
                <a
                  href={Path.signupAccount(config.URL || '')}
                  className="site-header__nav-help link-black link-borderless"
                >
                  <span className="help__text mr10 business-header__text">
                    {i18n.t('page.header.registration')}
                  </span>
                </a>
              </li>
              <li>
                <a
                  href={Path.loginAccount(config.URL || '')}
                  className="site-header__nav-help link-black link-borderless"
                >
                  <span className="help__text business-header__text">
                    {i18n.t('page.header.login')}
                  </span>
                </a>
              </li>
            </ul>

            <div className="business-header__smp">
              <input
                type="checkbox"
                className="site-header__drawer-check"
                id="site-header__drawer"
              />
              <label
                className="site-header__drawer-menu-btn"
                htmlFor="site-header__drawer"
              >
                <i className="fa fa-bars" />
              </label>
              <label
                className="site-header__drawer-close-menu"
                htmlFor="site-header__drawer"
              />
              <nav className="site-header__drawer-menu">
                <ul>
                  <li>
                    <div className="site-header__drawer-name-box">
                      <img
                        src={imagePath('stay/common/user_default_white.png')}
                        alt={'ゲスト'}
                        className="site-header__drawer-user-icon"
                      />
                      <p className="site-header__drawer-name-title">ゲスト</p>
                      <p className="site-header__drawer-user-name">
                        ログインしていません
                      </p>
                    </div>
                    <ul>
                      <li className="site-header__drawer-menu-list">
                        <a href={wwwUrl('/search?with_recommend=true')}>
                          <i className="fa fa-search" />
                          スペース検索
                        </a>
                      </li>
                      <li className="site-header__drawer-menu-list">
                        <a href={wwwUrl('/about')}>
                          <i className="fa fa-info-circle" />
                          ご利用ガイド
                        </a>
                      </li>
                      <li className="site-header__drawer-menu-list">
                        <a href={helpUrl()}>
                          <i className="fa fa-question" />
                          ヘルプ
                        </a>
                      </li>
                      <li className="site-header__drawer-menu-list">
                        <a href={Path.loginAccount(config.URL || '')}>
                          <i className="fa fa-sign-in" />
                          ログイン
                        </a>
                      </li>
                      <li className="site-header__drawer-menu-list">
                        <a href={Path.signupAccount(config.URL || '')}>
                          <i className="fa fa-user" />
                          新規登録
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div className="site-header__smp">
            <input
              type="checkbox"
              className="site-header__drawer-check"
              id="site-header__drawer"
            />
            <label
              className="business-header__drawer-menu-btn"
              htmlFor="site-header__drawer"
            >
              <i className="fa fa-bars site-header__search-menu-icon" />
            </label>
            <label
              className="site-header__drawer-close-menu"
              htmlFor="site-header__drawer"
            />
          </div>
          <div
            id="js-search"
            className="site-header__search-sm pc-hide__sm-show"
          />
        </div>
      </header>
    )
  }

  render() {
    const { data } = this.props
    const currentUser = data.viewer

    if (currentUser) return this.renderLoggedIn()
    else return this.renderAnonymous()
  }
}

function mapStateToProps(state) {
  return state
}
function mapDispatchToProps(dispatch) {
  const bindActions = { setUIState }
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderContainer)
